module.exports = __webpack_public_path__ + "img/left-arrow.ac21fd59.svg";